<template>
    <a-modal :title="`平台账户充值`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="待充值账号">
                    <span class="red"> {{ $store.state.user.userInfo?.username }} </span>
                </a-form-item>
                <a-form-item label="待充值账号身份证姓名">
                    <span class="red"> {{ $store.state.user.userInfo?.idcard_name }} </span>
                </a-form-item>
                <a-form-item label="手机号码">
                    <span class="red"> {{ $store.state.user.userInfo?.phone }} </span>
                </a-form-item>
                <a-form-item label="平台" name="platform_id" required>
                    <a-select v-model:value="formData.platform_id" placeholder="请选择平台" @change="changePlatform">
                        <a-select-option v-for="(item, index) in state.platformList" :key="index" :value="item.id">{{
                            item.platform_abbreviation }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="充值金额" name="money" required>
                    <a-input v-model:value="formData.money" placeholder="请输入充值金额" prefix="￥" suffix="RMB"></a-input>
                </a-form-item>
                <a-form-item label="付款方式">
                    <a-radio-group v-model:value="formData.payment_method" button-style="solid">
                        <a-radio :value="8" v-if="state.allowed_ptyecz_method.indexOf(8) != -1">微信扫码付款</a-radio>
                        <a-radio :value="1" v-if="state.allowed_ptyecz_method.indexOf(1) != -1">对公转账</a-radio>
                        <a-radio :value="2" v-if="state.allowed_ptyecz_method.indexOf(2) != -1">线下转款</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="对公转账信息" v-if="formData.payment_method == 1">
                    <pre>{{ state.bank_info }}</pre>
                </a-form-item>
                <div v-if="formData.payment_method == 1">
                    <a-form-item label="附件" name="attachment" required>
                        <Upload :upload_path="`public/uploads/manage/财务管理/账户充值/${dayjs().format('YYYYMM')}/`"
                            :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                            v-model:value="formData.attachment" :limitation="99" uploadText="上传附件">
                        </Upload>
                    </a-form-item>
                    <a-form-item label="备注">
                        <a-textarea v-model:value="formData.submit_reason" :rows="4" placeholder="请输入备注"></a-textarea>
                    </a-form-item>
                </div>
                <div v-if="formData.payment_method == 2">
                    <a-form-item label="附件" name="attachment">
                        <Upload :upload_path="`public/uploads/manage/财务管理/账户充值/${dayjs().format('YYYYMM')}/`"
                            :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                            v-model:value="formData.attachment" :limitation="99" uploadText="上传附件">
                        </Upload>
                    </a-form-item>
                    <a-form-item label="备注">
                        <a-textarea v-model:value="formData.submit_reason" :rows="4" placeholder="请输入备注"></a-textarea>
                    </a-form-item>
                </div>
                <div v-if="formData.payment_method == 8">
                    <a-form-item label="备注">
                        <a-textarea v-model:value="formData.submit_reason" :rows="4" placeholder="请输入备注"></a-textarea>
                    </a-form-item>
                    <a-form-item label="操作" v-if="formData.payment_method == 8">
                        <a-button type="primary" @click="onFormSubmit">点击弹出付款二维码</a-button>
                    </a-form-item>
                </div>
            </a-form>
        </a-skeleton>
    </a-modal>
    <!-- 微信扫码支付 -->
    <WechatPayQrcode v-if="state.showQrcode" :qrcodeData="state.qrcodeData" @cancel="state.showQrcode = false" @ok="
        () => {
            emit('ok')
        }
    "></WechatPayQrcode>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import Upload from '@/components/base/Upload.vue'
import WechatPayQrcode from '@/components/base/WechatPayQrcode.vue'
const $store = useStore()
import ls from '@/utils/Storage'
import PlatformPick from '@/components/base/PlatformPick.vue'
import dayjs from 'dayjs'
const UserInfo = ls.get('USER_INFO')
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
    submitLoading: boolean
    platformList: any[]
    showQrcode: boolean
    qrcodeData: any
    allowed_ptyecz_method: any[]
    bank_info: string

}
const state = reactive<IState>({
    loading: false,
    submitLoading: false,
    platformList: [],
    showQrcode: false,
    qrcodeData: {},
    allowed_ptyecz_method: [],
    bank_info: ''
})
interface IformData {
    platform_id: number | null
    money: number | null
    attachment: any[]
    submit_reason: string
    payment_method: number

}
const formData = reactive<IformData>({
    platform_id: null,
    money: null,
    attachment: [],
    submit_reason: '',
    payment_method: 8,
})
onMounted(() => {
    if (props.detailData) {
        formData.platform_id = props.detailData.platform_id
        changePlatform()
    }
    platformList()
})
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all' }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformList = res.data.list
            changePlatform()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
const changePlatform = () => {
    let platform = state.platformList.find((item) => item.id == formData.platform_id)
    state.allowed_ptyecz_method = platform?.allowed_ptyecz_method || []
    formData.payment_method = state.allowed_ptyecz_method[0] || null
    state.bank_info = platform?.bank_info || ''
}
// 提交
const onFormSubmit = () => {
    state.submitLoading = true
    ruleForm.value
        .validate()
        .then((res) => {
            let requeryParam = {
                url: '/admin/v1/platformBalance/recharge',
                method: 'post',
                data: { ...formData }
            }
            baseService(requeryParam)
                .then((res: any) => {
                    if (res.msg == 'showqrcode') {
                        //显示微信扫的二维码
                        state.qrcodeData = {
                            qrcode: res.data.code_url, //二维码url
                            qrcode_money: res.data.qrcode_money, //金额
                            payment_record_id: res.data.payment_record_id, //记录id
                            full_name: '快递预付款', //名称
                            trade_type: res.data.trade_type
                        }
                        state.showQrcode = true
                    } else {
                        message.success(res.msg)
                        emit('ok')
                    }
                    state.submitLoading = false
                })
                .catch((res) => {
                    state.submitLoading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                }).finally(() => {
                    state.submitLoading = false
                })
        })
        .catch((res) => {
            state.submitLoading = false
            message.warn('请检查必填项')
        })
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
